import { Footer } from "../../blocks/Footer/Footer";
import { MenuBottom } from "../../blocks/MenuBottom/MenuBottom";
import Header from "../../components/header/header";
import "../../core/core.css";
import { LoginForm } from "../../features/login/ui/LoginForm";
import { Services } from "../../features/service-list/ui/Services";
import "./../page.css";

const LoginPage = () => {
  return (
    <>
      <title>{"Вход в аккаунт — HMREP"}</title>
      <link rel="canonical" href="https://hmrep.ru/account/login/" />
      <meta
        name="description"
        content={
          " Управляйте заказами отзывов в личном кабинете, меняйте текста, распределяйте по датам, прикрепляйте фото."
        }
      />
      <div className="body">
        <Header></Header>
        <div className="blocks">
          <LoginForm></LoginForm>
          <Services></Services>
          <Footer></Footer>
        </div>
        <MenuBottom></MenuBottom>
      </div>
    </>
  );
};

export default LoginPage;
